var _path, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5495 8.00802C6.5495 8.30862 6.64356 8.45892 6.83168 8.45892C7.0198 8.45892 7.20297 8.38377 7.38119 8.23347L7.5 8.38377C7.13366 8.79459 6.70297 9 6.20792 9C5.85149 9 5.59406 8.90982 5.43564 8.72946C5.27723 8.53908 5.19802 8.23347 5.19802 7.81262V5.58667C5.19802 5.44639 5.13366 5.37625 5.00495 5.37625H4.54455L4.5 5.21092C4.69802 5.04058 4.94554 4.9003 5.24257 4.79008C5.5396 4.67986 5.83663 4.62475 6.13366 4.62475C6.25248 4.62475 6.35149 4.65481 6.43069 4.71493C6.5099 4.77505 6.5495 4.85521 6.5495 4.95541V8.00802ZM5.0495 3.18186C5.0495 3.0015 5.14851 2.8011 5.34653 2.58066C5.54455 2.36022 5.72772 2.25 5.89604 2.25C6.07426 2.25 6.26238 2.36022 6.4604 2.58066C6.66832 2.8011 6.77228 3.0015 6.77228 3.18186C6.77228 3.37224 6.66832 3.57766 6.4604 3.7981C6.26238 4.00852 6.07426 4.11373 5.89604 4.11373C5.72772 4.11373 5.54455 4.00852 5.34653 3.7981C5.14851 3.57766 5.0495 3.37224 5.0495 3.18186Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5.35,
    stroke: "black",
    strokeWidth: 1.3
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default ForwardRef;